export function normalizeForSearch(
	searchTerm: string
): NormalizedSearchTerm;
export function normalizeForSearch(
	searchTerm: string | undefined
): NormalizedSearchTerm | undefined;
export function normalizeForSearch(
	searchTerm: string | undefined
): NormalizedSearchTerm | undefined {
	return searchTerm?.toUpperCase() as (NormalizedSearchTerm | undefined);
}

export function contains(
	itemName: string | undefined,
	normalizedNotEmptySearchTerm: Exclude<string, ""> | undefined
): boolean {
	const normalizedItemName: string | undefined = normalizeForSearch(itemName);

	if (typeof normalizedItemName === "undefined") {
		return false;
	}

	if (typeof normalizedNotEmptySearchTerm === "undefined") {
		return false;
	}

	return normalizedItemName.indexOf(normalizedNotEmptySearchTerm) >= 0;
}

const isNormalizedForSearchProperty = Symbol();

export type NormalizedSearchTerm = string & {
	[isNormalizedForSearchProperty]: true;
};

